<template>
  <swiper
    :loop="false"
    :speed="1400"
    :spaceBetween="25"
    :grabCursor="true"
    :autoplay="{
      delay: 5000,
      disableOnInteraction: true,
    }"
    :breakpoints="{
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2.2,
      },
      992: {
        slidesPerView: 2.4,
      },
      1200: {
        slidesPerView: 3,
      },
      1400: {
        slidesPerView: 4,
      },
    }"
    :modules="modules"
    class="home_one-testimonial-slider-two"
  >
    <swiper-slide v-for="testimonial in testimonials" :key="testimonial.id">
      <div class="testimonial-card bg-magnolia round-10">
        <ul class="rating list-style">
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-fill.svg" alt="Image" />
          </li>
          <li>
            <img src="../../assets/img/icons/star-line.svg" alt="Image" />
          </li>
        </ul>
        <p>
          {{ testimonial.description }}
        </p>
        <div class="d-flex align-items-center justify-content-between">
          <h6>{{ testimonial.name }}</h6>
          <img src="../../assets/img/icons/quote.svg" alt="Image" />
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default {
  name: "WhatOurCustomerSaysTwo",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          description:
            "Mazii saved our long-distance relationship! The widgets make us feel connected even when we're thousands of miles apart. Best app ever!",
          name: "Jessica & Mark",
        },
        {
          id: 2,
          description:
            "The anniversary reminders are a lifesaver! I never forget important dates anymore, and my girlfriend loves the surprise notifications.",
          name: "Carlos & Ana",
        },
        {
          id: 3,
          description:
            "We've been using Mazii for 6 months and it's become part of our daily routine. The secret moments feature keeps the spark alive!",
          name: "Taylor & Sam",
        },
        {
          id: 4,
          description:
            "Simple, beautiful, and effective. Mazii helps us share little moments throughout the day that make our relationship stronger.",
          name: "Rachel & Tom",
        },
        {
          id: 5,
          description:
            "The widget templates are gorgeous and the app is so intuitive. Perfect for couples who want to stay connected in a meaningful way.",
          name: "Priya & James",
        },
        {
          id: 6,
          description:
            "Mazii brings back the excitement of receiving love notes. Every widget update feels like a sweet surprise from my partner.",
          name: "Chloe & Alex",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>

<style lang="scss" scoped>
.home_one-testimonial-slider-two {
  .testimonial-card {
    padding: 25px;
    border-radius: 6px;
    p {
      margin: 15px 0 20px;
    }
    h6 {
      color: rgba(37, 27, 66, 0.7);
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 0;
    }
    .rating {
      line-height: 1;
      li {
        line-height: 1;
        margin-right: 5px;
        i {
          color: #f3795d;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_one-testimonial-slider-two {
    margin: 0 12px;
  }
}

@media only screen and (min-width: 1400px) {
  .home_one-testimonial-slider-two {
    .testimonial-card {
      padding: 32px 30px 30px 35px;
    }
    margin: 0 76px;
  }
}
</style>